"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const jsxRuntime = require("react/jsx-runtime");
const React = require("react");
const hooks_useIsClient = require("../../hooks/use-is-client.js");
const foundations_icons_IconsDefault = require("./IconsDefault.js");
const Icon = ({
  variant,
  CustomIcon,
  width = 24,
  height = 24,
  fallBackProps,
  ...svgProps
}) => {
  const isClient = hooks_useIsClient.useIsClient();
  const FallbackComponent = ({ style, ...props }) => /* @__PURE__ */ jsxRuntime.jsx("span", { style, ...props });
  const fallback = /* @__PURE__ */ jsxRuntime.jsx(FallbackComponent, { style: { width, height }, ...fallBackProps });
  if (!isClient) {
    return fallback;
  }
  if (CustomIcon) {
    return /* @__PURE__ */ jsxRuntime.jsx(React.Suspense, { fallback, children: /* @__PURE__ */ jsxRuntime.jsx(CustomIcon, { width, height, ...svgProps }) });
  }
  if (variant) {
    const VariantIcon = foundations_icons_IconsDefault.getIconByName(variant);
    return /* @__PURE__ */ jsxRuntime.jsx(React.Suspense, { fallback, children: /* @__PURE__ */ jsxRuntime.jsx(VariantIcon, { width, height, ...svgProps }) });
  }
  return fallback;
};
exports.Icon = Icon;
